// export const hasScreenPermission = (permissions: any[], screenId: any) => {
//     if (!permissions) return false;
//     return permissions.some((p: { screen_id: any; }) => Number(p.screen_id) === Number(screenId));
//   };

//   export const hasSubScreenPermission = (permissions: any[], screenId: any, subScreenId: any) => {
//     if (!permissions) return false;

//     const screen = permissions.find(
//       (p) => Number(p.screen_id) === Number(screenId)
//     );

//     if (!screen) return false;

//     return screen.sub_screens.some(
//       (sub: { sub_screen_id: any; enabled: any; }) => Number(sub.sub_screen_id) === Number(subScreenId) && Number(sub.enabled) === 1
//     );
//   };

export const hasMenuPermission = (permissions: any[], menuId: any): boolean => {
    if (!permissions) return false;
    return permissions.some(p => Number(p.menu_id) === Number(menuId));
};

export const hasScreenPermission = (permissions: any[], menuId: any, screenId: any): boolean => {
    if (!permissions) return false;
    const menu = permissions.find(p => Number(p.menu_id) === Number(menuId));
    if (!menu || !menu.screens) return false;
    return menu.screens.some((screen: any) => Number(screen.screen_id) === Number(screenId));
};

export const hasSubScreenPermission = (permissions: any[], menuId: any, screenId: any, subScreenId: any): boolean => {
    if (!permissions) return false;
    const menu = permissions.find(p => Number(p.menu_id) === Number(menuId));
    if (!menu || !menu.screens) return false;
    const screen = menu.screens.find((s: any) => Number(s.screen_id) === Number(screenId));
    if (!screen || !screen.sub_screens) return false;
    return screen.sub_screens.some(
        (sub: any) => Number(sub.sub_screen_id) === Number(subScreenId) && !!sub.enabled
    );
};
export const canAddPurchase = (permissions: any[]) => {
    const menu = permissions.find((m) => m.menu_id == "1");
    if (!menu) return false;
  
    const screen = menu.screens.find((s: any) => s.screen_id == "2");
    if (!screen) return false;
  
    const sub = screen.sub_screens.find((x: any) => x.sub_screen_id == "4");
    if (!sub) return false;
  
    return sub.add_enable === true;
  };
  
